import { Component, OnInit, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { HrisIntegrationDataService } from '../../services/hris-integration-data.service';
import { HrisIntegrationSetupButtonComponent } from '../hris-integration-setup-button/hris-integration-setup-button.component';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hris-integration-button',
  imports: [TranslocoPipe, HrisIntegrationSetupButtonComponent, MatIcon],
  templateUrl: './hris-integration-button.component.html',
})
export class HrisIntegrationButtonComponent implements OnInit {
  protected readonly hrisIntegrationDataService = inject(
    HrisIntegrationDataService,
  );
  protected readonly router = inject(Router);

  ngOnInit(): void {
    this.hrisIntegrationDataService.init();
  }

  get statusClass(): string {
    if (!this.hrisIntegrationDataService.hrisIntegration) {
      return '';
    }
    switch (this.hrisIntegrationDataService.hrisIntegration.status) {
      case 'active':
        return 'text-success';
      case 'inactive':
        return 'text-warning';
      case 'error':
        return 'text-danger';
      default:
        return '';
    }
  }
}
